import {
    HttpErrorResponse,
    HttpEvent, HttpEventType,
    HttpHandler,
    HttpInterceptor,
    HttpProgressEvent,
    HttpRequest, HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { concat, Observable, of } from 'rxjs';
import { delay, tap } from 'rxjs/operators';
import { AppInitializerService } from './app-initializer.service';
import { LoadingService } from '../../common/layout/loading.service';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
    constructor(
        private router: Router,
        private initializer: AppInitializerService,
        private loadingService: LoadingService
    ) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            tap(() => {
            }, (err: any) => {
                if (err instanceof HttpErrorResponse && this.initializer.isInitialized) {
                    if (err.status === 401) {
                        this.router.navigateByUrl('/logowanie');
                    } else if (err.status === 500) {
                        this.loadingService.stop();
                    } else if (err.status !== 404) {
                    }
                }
            })
        );
    }
}
